(function() {
  $(document).on('fields_added.nested_form_fields', function() {
    $('.nested_fields').scTooltips();
  })
}());
